(function () {
    'use strict';

    function AdminApprovalCtrl(restangular, toastr, $scope) {
        var vm = this;

        vm.searchOptions = {
            size: 10,
            page: 1
        };
        
        vm.approveUser = approveUser;
        vm.removeUser = removeUser;

        $scope.$watch(function () { return vm.searchOptions; }, fetch, true);

        ////////////////////////////////////////
        function fetch() {
            restangular
                .one('users')
                .one('pending')
                .get(vm.searchOptions)
                .then(function (users) {
                    vm.approvals = users;
                });
        }

        function approveUser(user) {
            restangular
                .one('users')
                .post('approve', JSON.stringify(user.id))
                .then(function () {
                fetch();
                    toastr.info('User has been approved.', 'User Approved');
                });
        }

        function removeUser(user) {
            restangular
                .one('users', user.id)
                .one(true)
                .remove()
                .then(function () {
                fetch();
                    toastr.info('User has been removed.', 'User Removed');
                });
        }
    };

    angular
        .module('app')
        .controller('AdminApprovalCtrl', ['Restangular', 'toastr', '$scope', AdminApprovalCtrl]);

})();